import { isDashboardApp } from "@/core/services/domain.service";
import { routes } from "@/routing/routes";
import { MODULE_TIM, STORE_MANAGER, STORE_SELLER } from "@/core/models/usersAndPermissions";
import identificationService from "@/core/services/identification.service";
import { useLayoutConfigStore } from "@/core/store/config/configStore";
import { useCartStore } from "@/core/store/cart/cartStore";
import { storeToRefs } from "pinia";
import { computed, ref, onMounted } from "vue";
import { useRoute } from "vue-router";

export function useTopbar() {
  const isDashboard = isDashboardApp();
  const route = useRoute();

  const { getLayoutConfig } = useLayoutConfigStore();
  const { show, isCartEmpty, cart } = storeToRefs(useCartStore());

  const user = ref(null);

  onMounted(() => {
    user.value = identificationService.getUser();
  });

  const headerUserDisplay = computed(() => {
    return !!user.value && !!getLayoutConfig("header.user.display");
  });

  const publicAppCartDisplay = computed(() => {
    return route.name !== routes.buybackConfirmation.name && route.name !== routes.cartCheckout.name;
  });

  const isStoreManagerOrSeller = computed(() => {
    return (
      identificationService.isModuleType(MODULE_TIM) &&
      (identificationService.isUserType(STORE_MANAGER) || identificationService.isUserType(STORE_SELLER))
    );
  });

  const dashboardCartDisplay = computed(() => {
    return show.value && isStoreManagerOrSeller.value;
  });

  const headerCartDisplay = computed(() => {
    return isDashboard ? dashboardCartDisplay.value : publicAppCartDisplay.value;
  });

  return {
    user,
    isCartEmpty,
    cart,
    headerUserDisplay,
    publicAppCartDisplay,
    isStoreManagerOrSeller,
    dashboardCartDisplay,
    headerCartDisplay,
  };
}
